import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCDealAutomations(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 504.605 421.525">
            <defs>
                <linearGradient
                    id="linear-deal-automations"
                    x1="0.694"
                    y1="-34.593"
                    x2="0.398"
                    y2="18.882"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stopColor="#201b59" />
                    <stop offset="1" stopColor="#2d2d84" />
                </linearGradient>
                <linearGradient
                    id="linear-deal-automations-2"
                    x1="0.654"
                    y1="-21.974"
                    x2="0.409"
                    y2="14.334"
                    xlinkHref="#linear-deal-automations"
                />
                <linearGradient
                    id="linear-deal-automations-3"
                    x1="0.64"
                    y1="-20.697"
                    x2="0.4"
                    y2="15.44"
                    xlinkHref="#linear-deal-automations"
                />
                <linearGradient
                    id="linear-deal-automations-4"
                    x1="0.642"
                    y1="-19.737"
                    x2="0.387"
                    y2="16.806"
                    xlinkHref="#linear-deal-automations"
                />
            </defs>
            <g id="Deal_Automations" transform="translate(-2.39 -45.885)">
                <g id="Layer_1" data-name="Layer 1">
                    <ellipse
                        id="_Path_"
                        data-name="&lt;Path&gt;"
                        cx="220.71"
                        cy="59.86"
                        rx="220.71"
                        ry="59.86"
                        transform="translate(56.84 347.69)"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_1"
                        data-name="Path 1"
                        d="M392.05,279.24c1.43,1.11,40.51-1.72,56.93,1.67,0,0,12.73-55.52-23.82-57.71S376,243.57,376,243.57Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_2"
                        data-name="Path 2"
                        d="M353.46,220.59l71.7,2.61s-26.13.36-23.23,33.41,17.62,129.54-19.78,129.64-38-17-38-17Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_3"
                        data-name="Path 3"
                        d="M320,205.08l27.72-6.45s18.53-1.67,21,14.81,1.78,114.06,1,134.18,1.1,35.61,12.43,38.63l-82.4,1.42Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_4"
                        data-name="Path 4"
                        d="M263.62,206.42s50.47,2.78,84.07-7.79c0,0-22.34-1.53-22.34,50,0,39.42,5.85,114.67.74,129s-24.19,33.48-51.55,17S263.62,206.42,263.62,206.42Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_5"
                        data-name="Path 5"
                        d="M250.2,129.11s55.69,6.07,62.86-3.37c0,0-5.71-17-22.65-15.85S250.2,129.11,250.2,129.11Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M69.1,148.22c4.85,54.58,15.05,170,19.49,226.23a25.28,25.28,0,0,0,23.58,23.24c44.7,2.87,145.29,8.44,183.9,3.26h0a25.69,25.69,0,0,1-14.33-23.26l2.05-252.3c.07-8.92,8.95-15.33,17.3-12.2,5.26,2,9.24,6.17,12,12.55-3.64-10.62-9.38-18.39-22.65-15.85,0,0-129.84,1.3-192.85,5.2A30.48,30.48,0,0,0,69.1,148.22Z"
                        fill="#707272"
                    />
                    <g id="Group_1" data-name="Group 1">
                        <path
                            id="Path_7"
                            data-name="Path 7"
                            d="M101.22,122.31l174.46-6.71c-7.19,53.27-4.15,161.76-1.41,268.68A16.8,16.8,0,0,0,283.88,399h0s-116.37,1.34-166.37-2.21a25.19,25.19,0,0,1-23.12-21.41C87.52,329.6,71.1,211.26,74.52,148.61a27.82,27.82,0,0,1,26.7-26.3Z"
                            fill="#e4e3e3"
                        />
                    </g>
                    <path
                        id="Path_8"
                        data-name="Path 8"
                        d="M110.55,318.39l1.81,15.52c.33,2.84,3.17,5.06,6.66,5.21l11,.47c4,.16,7.33-2.4,7.37-5.66l.18-16.71c0-3.35-3.44-6-7.54-5.8l-13,.73C113.1,312.37,110.18,315.19,110.55,318.39Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_9"
                        data-name="Path 9"
                        d="M149.46,314.51c18.41-.35,89-1.8,106.88-2.17a3.93,3.93,0,0,1,4.07,3.91h0a3.92,3.92,0,0,1-3.88,3.82l-106.81,2.67a4,4,0,0,1-4.07-3.41l-.06-.51a3.9,3.9,0,0,1,3.87-4.31Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_10"
                        data-name="Path 10"
                        d="M148,338.77h0a1.61,1.61,0,0,0,1.42.82l70.07-.77a1.63,1.63,0,0,0,1.6-1.63l.05-4.69a1.63,1.63,0,0,0-1.66-1.66l-68.13,1.84a4.06,4.06,0,0,0-3.35,6.09Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_11"
                        data-name="Path 11"
                        d="M108.53,275.72l1.81,15.4c.33,2.82,3.17,5,6.66,5.17l11.05.47c4,.16,7.33-2.38,7.37-5.61l.18-16.59c0-3.33-3.45-6-7.55-5.76l-13,.72C111.08,269.74,108.15,272.54,108.53,275.72Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_12"
                        data-name="Path 12"
                        d="M147.44,271.88c18.4-.35,89-1.8,106.88-2.17a3.94,3.94,0,0,1,4.07,3.91h0a3.92,3.92,0,0,1-3.88,3.82l-106.82,2.67a4,4,0,0,1-4.06-3.41l-.06-.5a3.9,3.9,0,0,1,3.87-4.32Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_13"
                        data-name="Path 13"
                        d="M146,296.15h0a1.71,1.71,0,0,0,1.48.82l73.33-.74a1.67,1.67,0,0,0,1.68-1.63l.05-4.69a1.67,1.67,0,0,0-1.74-1.66l-71.3,1.8a4.06,4.06,0,0,0-3.5,6.1Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_14"
                        data-name="Path 14"
                        d="M159.42,230.29c16.71-.37,80.86-1.89,97.06-2.28a3.74,3.74,0,0,1,3.69,3.91h0a3.76,3.76,0,0,1-3.53,3.82l-97,2.78a3.71,3.71,0,0,1-3.69-3.41v-.5a3.79,3.79,0,0,1,3.47-4.32Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_15"
                        data-name="Path 15"
                        d="M152.93,254.5h0a1.69,1.69,0,0,0,1.45.82l71.55-.76a1.65,1.65,0,0,0,1.64-1.63l.05-4.69a1.65,1.65,0,0,0-1.7-1.66l-69.57,1.82a4.06,4.06,0,0,0-3.42,6.1Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_16"
                        data-name="Path 16"
                        d="M161.05,189.38c16.81-.37,81.36-1.88,97.65-2.27a3.74,3.74,0,0,1,3.71,3.91h0a3.77,3.77,0,0,1-3.54,3.82l-97.6,2.77a3.71,3.71,0,0,1-3.7-3.41l-.06-.5a3.8,3.8,0,0,1,3.54-4.32Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_17"
                        data-name="Path 17"
                        d="M159.08,213.64h0a1.52,1.52,0,0,0,1.34.82l66.66-.81a1.6,1.6,0,0,0,1.53-1.63v-4.69a1.6,1.6,0,0,0-1.58-1.66l-64.81,1.87a4.08,4.08,0,0,0-3.14,6.1Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_18"
                        data-name="Path 18"
                        d="M318.8,319.14a.85.85,0,0,1-.85-.83s-.05-2.7-.31-11.87a.85.85,0,0,1,1.7-.05c.25,9.18.31,11.86.31,11.89a.84.84,0,0,1-.84.86Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_19"
                        data-name="Path 19"
                        d="M318.18,296.76a.85.85,0,0,1-.85-.82c-.18-6-.47-12.57-.77-19.56-.4-9.44-.82-19.2-1.05-28.6-.58-24.82,3.51-34.35,7.05-38,1.92-2,3.53-2,3.71-2a.85.85,0,0,1,0,1.7c-.2,0-10,1.09-9.08,38.26.22,9.38.64,19.14,1.05,28.57.3,7,.59,13.59.77,19.57a.86.86,0,0,1-.82.88Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_20"
                        data-name="Path 20"
                        d="M399,294a.85.85,0,0,1-.85-.8c0-.23-1.36-22.6-3.79-41.22-2.51-19.31,8.06-23.39,8.51-23.55a.85.85,0,0,1,.59,1.59h0c-.4.15-9.74,3.86-7.41,21.74,2.43,18.68,3.78,41.11,3.8,41.34a.86.86,0,0,1-.8.9Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_21"
                        data-name="Path 21"
                        d="M132.35,241.73c0-.45-.5-.84-1.28-1.16.85-.46,1.32-1,1.28-1.46-.12-1.48-4.83-2.32-10.52-1.86s-10.2,2-10.08,3.53c0,.45.49.84,1.27,1.15-.84.47-1.31,1-1.27,1.46s.49.84,1.27,1.15c-.84.47-1.31,1-1.27,1.46s.49.85,1.27,1.16c-.84.47-1.31,1-1.27,1.46,0,.66,1,1.19,2.54,1.53a12.789,12.789,0,0,0,0,1.61c.22,2.74,3.3,4.89,7.38,4.89s7.6-2.93,7.64-5.68a13.93,13.93,0,0,0-.08-1.79c1.95-.65,3.14-1.45,3.08-2.22,0-.45-.5-.84-1.28-1.16.85-.46,1.32-1,1.28-1.46s-.5-.84-1.28-1.15C131.92,242.72,132.39,242.22,132.35,241.73Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_22"
                        data-name="Path 22"
                        d="M119,250.75a25,25,0,0,1-4.51-.37.15.15,0,0,1-.11-.16.13.13,0,0,1,.16-.11,30,30,0,0,0,7.52.24,32.641,32.641,0,0,0,6.3-1.09.13.13,0,0,1,.17.09.14.14,0,0,1-.09.17,32.5,32.5,0,0,1-6.36,1.1C121,250.7,120,250.75,119,250.75Z"
                        fill="url(#linear-deal-automations)"
                    />
                    <path
                        id="Path_23"
                        data-name="Path 23"
                        d="M119,248.13a21.65,21.65,0,0,1-5.54-.6.141.141,0,0,1,.08-.27,26.149,26.149,0,0,0,8.49.47,26.73,26.73,0,0,0,8.26-1.8.14.14,0,0,1,.11.25,27,27,0,0,1-8.35,1.82C121.05,248.09,120,248.13,119,248.13Z"
                        fill="url(#linear-deal-automations-2)"
                    />
                    <path
                        id="Path_24"
                        data-name="Path 24"
                        d="M119,245.52a20,20,0,0,1-5.84-.71.13.13,0,0,1-.08-.17.14.14,0,0,1,.17-.09,25.12,25.12,0,0,0,8.81.57,26.73,26.73,0,0,0,8.26-1.8.137.137,0,1,1,.11.25,27,27,0,0,1-8.35,1.82C121,245.47,120,245.52,119,245.52Z"
                        fill="url(#linear-deal-automations-3)"
                    />
                    <path
                        id="Path_25"
                        data-name="Path 25"
                        d="M119,242.9a23.24,23.24,0,0,1-4.92-.45.133.133,0,1,1,.06-.26,28.841,28.841,0,0,0,7.9.31,26.781,26.781,0,0,0,8.22-1.78.137.137,0,1,1,.11.25,27,27,0,0,1-8.31,1.8C121,242.86,120,242.9,119,242.9Z"
                        fill="url(#linear-deal-automations-4)"
                    />
                    <path
                        id="Path_26"
                        data-name="Path 26"
                        d="M107.74,228.53a19.28,19.28,0,0,0-3.44-6.73A44.47,44.47,0,0,1,94.7,197c-1-17.24,14.3-25.87,28.25-24.7s27.71,11.56,26.2,27.59c-.93,9.87-6.45,17.35-10.56,21.65a22.86,22.86,0,0,0-5.48,9.71c-1.23,4.45-4.17,10-11.15,10.34C112.93,242,109.18,233.62,107.74,228.53Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_27"
                        data-name="Path 27"
                        d="M124.27,238.17l4.88-31.74c.1-.66.42-1.1.72-1s.46.74.35,1.39v.06l-5.56,31.45c0,.23-.17.38-.27.33S124.23,238.4,124.27,238.17Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_28"
                        data-name="Path 28"
                        d="M119.2,238.42l-4.88-31.74c-.1-.66-.42-1.1-.72-1s-.46.74-.35,1.4h0l5.56,31.45c0,.23.17.38.27.33S119.24,238.65,119.2,238.42Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_29"
                        data-name="Path 29"
                        d="M125.79,205.54a.51.51,0,0,0-.64-.17l-2.71,1.27-1-2.69a.56.56,0,0,0-.33-.33.67.67,0,0,0-.83.26h0L118.09,208l-2.08-5.8h0a.66.66,0,0,0-.31-.35.82.82,0,0,0-1,.2l-3.12,4.3a.37.37,0,0,0,.11.54.52.52,0,0,0,.66-.07l2.75-3.07,2.48,5.52h0a.43.43,0,0,0,.22.22.52.52,0,0,0,.65-.17l2.39-3.83.9,1.94h0a.51.51,0,0,0,.64.17l3.22-1.51a.37.37,0,0,0,.19-.55Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_30"
                        data-name="Path 30"
                        d="M138.7,217.07a.19.19,0,0,1-.14,0,.23.23,0,0,1-.05-.32,35.926,35.926,0,0,0,2.29-3.48.233.233,0,1,1,.4.24,38.094,38.094,0,0,1-2.32,3.52.21.21,0,0,1-.18.04Z"
                        fill="#fff"
                        opacity="0.79"
                    />
                    <path
                        id="Path_31"
                        data-name="Path 31"
                        d="M142.71,210.18h-.09a.23.23,0,0,1-.12-.3,29.34,29.34,0,0,0,.66-22.26.233.233,0,0,1,.42-.2,24.54,24.54,0,0,1,1.69,6.69A30.62,30.62,0,0,1,142.92,210a.22.22,0,0,1-.21.18Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_32"
                        data-name="Path 32"
                        d="M227.94,386.62a3.74,3.74,0,0,1-2.49-1.19c-3.42-3.14-4.2-8.07-4.4-12.68-1.65,1.87-3.36,3.69-5,5.48l-.54-.51c1.86-2,3.74-4,5.55-6.05a133.518,133.518,0,0,1,.84-18.54,37.79,37.79,0,0,1,2.67-11.27,9,9,0,0,1,2.78-3.75,4.24,4.24,0,0,1,4.67-.29c1.45,1,1.84,2.85,2,4.17,1,8-2.09,15.32-4.89,20.06a67.678,67.678,0,0,1-7.33,9.89c.13,4.67.77,9.81,4.18,12.95a3,3,0,0,0,2.05,1c1,0,1.84-1,2.5-1.93a50.79,50.79,0,0,0,6.58-13.15,13.3,13.3,0,0,1,1.15-4l.69.24c-.32,1.33-.69,2.64-1.12,3.93a12.829,12.829,0,0,0,.16,4c.14.72.76,3.12,2.58,3.47,1.37.26,2.72-.7,4.24-3l5.25-8-.47,2c-.27,1.2-.73,4.06,1,4.78,1,.41,2-.18,3.16-.81a5.63,5.63,0,0,1,3.4-1.06l.38.05-.07.38c-.28,1.66-.14,3.71,1.22,4,.89.19,1.61-.47,2.45-1.24a5.45,5.45,0,0,1,2.33-1.54l.18.72a5.06,5.06,0,0,0-2,1.36c-.91.83-1.84,1.7-3.11,1.42-1.74-.39-2.1-2.48-1.85-4.44a5.781,5.781,0,0,0-2.55,1c-1.22.68-2.48,1.39-3.81.84S248.45,373,248.6,371l-3.18,4.82c-1.07,1.64-2.76,3.76-5,3.33-1.53-.29-2.72-1.8-3.17-4a15.174,15.174,0,0,1-.24-1.9,50.809,50.809,0,0,1-5.89,11.11c-.75,1.08-1.71,2.2-3.07,2.25ZM230,338a4,4,0,0,0-2.25.73,8.33,8.33,0,0,0-2.53,3.45,37.62,37.62,0,0,0-2.61,11.06,132.874,132.874,0,0,0-.85,17.62,64.8,64.8,0,0,0,6.72-9.17c2.74-4.64,5.8-11.8,4.8-19.58-.24-1.88-.78-3-1.69-3.66A2.87,2.87,0,0,0,230,338Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_33"
                        data-name="Path 33"
                        d="M230.07,393.46a24.14,24.14,0,1,1,24.14-24.14,24.14,24.14,0,0,1-24.14,24.14Zm0-47.76a23.62,23.62,0,1,0,23.63,23.623A23.62,23.62,0,0,0,230.07,345.7Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_34"
                        data-name="Path 34"
                        d="M357.15,355.91l1.68,39.35a12.8,12.8,0,0,0,12.87,12.23l94.26-.41a9.23,9.23,0,0,0,9.13-8c1.38-10,3.07-27.76.78-44.43Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_35"
                        data-name="Path 35"
                        d="M374.19,405.05a.085.085,0,0,1,0-.17h.68a.085.085,0,0,1,0,.17Zm2.26,0a.085.085,0,0,1,0-.17h.68a.085.085,0,0,1,0,.17Zm2.26,0a.085.085,0,0,1,0-.17h.68a.08.08,0,0,1,.08.08.09.09,0,0,1-.08.09Zm2.26,0a.085.085,0,1,1,0-.17h.68a.085.085,0,0,1,0,.17Zm2.26,0a.085.085,0,1,1,0-.17h.67a.09.09,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.085.085,0,1,1,0,.17Zm-12.88,0h0l-.68-.08a.09.09,0,1,1,0-.17l.66.08a.1.1,0,0,1,.08.1.09.09,0,0,1-.06.02Zm15.13,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.26,0a.07.07,0,0,1-.08-.08.08.08,0,0,1,.08-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.07.07,0,0,1-.08-.08.08.08,0,0,1,.08-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.09.09,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.7a.085.085,0,1,1,0,.17Zm2.25,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.26,0a.085.085,0,0,1,0-.17h.68a.085.085,0,0,1,0,.17Zm2.26,0a.07.07,0,0,1-.08-.08.08.08,0,0,1,.08-.09H411a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.1.1,0,0,1,.08.09.09.09,0,0,1-.08.08Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.085.085,0,1,1,0,.17Zm2.25,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09H420a.085.085,0,1,1,0,.17h-.68Zm2.26,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.26,0a.085.085,0,0,1,0-.17h.68a.085.085,0,0,1,0,.17Zm2.26,0a.07.07,0,0,1-.08-.08.08.08,0,0,1,.08-.09h.68a.09.09,0,0,1,.08.09.08.08,0,0,1-.08.08Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.08.08,0,0,1,.09.09.09.09,0,0,1-.08.08Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.085.085,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.25,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.07.07,0,0,1-.08-.08.08.08,0,0,1,.08-.09h.68a.09.09,0,0,1,.08.09.08.08,0,0,1-.08.08Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.085.085,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.08-.09h.68a.088.088,0,0,1,.09.09.09.09,0,0,1-.09.08Zm2.25,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.07.07,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.09.09,0,0,1-.09-.08.093.093,0,0,1,.09-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08c0-.05,0-.08.09-.09H463a.085.085,0,0,1,0,.17Zm2.25-.06a.08.08,0,1,1,0-.16l.66-.1a.09.09,0,0,1,.1.06.08.08,0,0,1-.07.1,5.061,5.061,0,0,1-.68.1Zm-94.13,0h0c-.22-.06-.44-.13-.65-.21a.084.084,0,0,1,.05-.16c.21.08.43.15.64.21a.08.08,0,0,1,.06.1.187.187,0,0,1-.1-.36Zm96.32-.5a.082.082,0,0,1-.03-.16l.62-.26a.078.078,0,0,1,.11.11,6,6,0,0,1-.63.27Zm-98.42-.33h0a5.77,5.77,0,0,1-.6-.33.081.081,0,0,1,.08-.14l.59.32a.08.08,0,0,1,0,.11.193.193,0,1,1-.07-.38ZM468.71,403a.07.07,0,0,1-.07-.12c.18-.13.36-.26.53-.41a.085.085,0,0,1,.12.12q-.27.23-.54.42Zm-102.31-.47h0c-.18-.14-.36-.28-.53-.43a.08.08,0,0,1,0-.12.09.09,0,0,1,.12,0l.52.43a.07.07,0,0,1,0,.11.06.06,0,0,1-.11.02Zm104-1.07a.06.06,0,0,1-.05,0,.08.08,0,0,1,0-.12c.14-.17.28-.35.41-.53a.08.08,0,0,1,.12,0,.11.11,0,0,1,0,.12l-.42.54a.09.09,0,0,1-.11,0ZM364.74,401a.07.07,0,0,1-.06,0c-.15-.17-.3-.34-.44-.52a.08.08,0,0,1,0-.12.09.09,0,0,1,.12,0c.14.18.28.35.43.52a.09.09,0,0,1,0,.12Zm106.82-1.44h0a.08.08,0,0,1,0-.11c.09-.2.18-.41.26-.62a.09.09,0,0,1,.11-.05.1.1,0,0,1,0,.11q-.12.32-.27.63a.08.08,0,0,1-.1.05Zm-108.17-.37a.1.1,0,0,1-.07,0c-.12-.19-.23-.39-.34-.59a.081.081,0,0,1,.11-.12l.33.58a.08.08,0,0,1,0,.12Zm108.84-1.78h0a.08.08,0,0,1-.07-.1.76.76,0,0,1,.05-.33l.05-.34s.05-.07.09-.07a.1.1,0,0,1,.08.1l-.05.33a.783.783,0,0,1-.05.34.1.1,0,0,1-.1.08Zm-109.83-.25a.1.1,0,0,1-.08-.05c-.08-.22-.15-.43-.22-.65a.1.1,0,0,1,.06-.11.09.09,0,0,1,.1.06c.07.21.14.43.22.64a.08.08,0,0,1-.05.11Zm110.14-2h0a.09.09,0,0,1-.08-.09l.09-.67a.09.09,0,0,1,.09-.08.1.1,0,0,1,.08.1l-.09.67a.08.08,0,0,1-.09.09ZM361.81,395a.1.1,0,0,1-.09-.07c0-.23-.07-.45-.09-.68a.08.08,0,1,1,.16,0,3.876,3.876,0,0,0,.1.67.07.07,0,0,1-.07.09Zm111-2.06h0s-.08-.05-.07-.09l.08-.68a.081.081,0,1,1,.16.02l-.07.68a.1.1,0,0,1-.1.07Zm-111.2-.19a.1.1,0,0,1-.09-.08v-.68a.08.08,0,0,1,.08-.09.09.09,0,0,1,.08.08v.68a.08.08,0,0,1-.08.09Zm111.45-2.05h0a.09.09,0,0,1-.07-.1,2.185,2.185,0,0,1,.07-.67.08.08,0,0,1,.16,0,2.186,2.186,0,0,1-.07.67.09.09,0,0,1-.09.1Zm-111.55-.21a.08.08,0,0,1-.08-.08v-.68a.08.08,0,0,1,.08-.08.09.09,0,0,1,.09.08v.67a.09.09,0,0,1-.08.09Zm111.77-2h0a.09.09,0,0,1-.08-.1l.06-.67a.09.09,0,0,1,.09-.08.1.1,0,0,1,.08.1l-.06.67a.1.1,0,0,1-.09.04Zm-111.86-.21a.09.09,0,0,1-.09-.09v-.67a.09.09,0,0,1,.08-.09.08.08,0,0,1,.09.08v.68A.09.09,0,0,1,361.42,388.28Zm112.06-2h0s-.08-.05-.07-.09a3.118,3.118,0,0,1,.05-.68.085.085,0,0,1,.17.01,3.072,3.072,0,0,1-.05.68.11.11,0,0,1-.1,0ZM361.32,386a.09.09,0,0,1-.08-.08v-.68a.08.08,0,0,1,.08-.09.1.1,0,0,1,.09.08v.68A.09.09,0,0,1,361.32,386Zm112.33-2h0a.08.08,0,0,1-.08-.09v-.67a.09.09,0,0,1,.09-.08.08.08,0,0,1,.08.09c0,.23,0,.45,0,.68a.09.09,0,0,1-.09.01Zm-112.43-.22a.08.08,0,0,1-.08-.08v-.68a.09.09,0,0,1,.08-.08.08.08,0,0,1,.09.08v.67a.08.08,0,0,1-.08.09Zm112.58-2h0a.09.09,0,0,1-.08-.09v-.68a.1.1,0,0,1,.09-.08.09.09,0,0,1,.08.09v.68a.08.08,0,0,1-.09-.01Zm-112.67-.22c-.05,0-.08,0-.09-.09v-.67a.08.08,0,0,1,.08-.09.09.09,0,0,1,.09.08v.68a.091.091,0,0,1-.08.09Zm112.79-2h0a.09.09,0,0,1-.08-.08v-.68a.09.09,0,0,1,.09-.08.08.08,0,0,1,.08.09v.67a.08.08,0,0,1-.09-.05ZM361,379.21a.09.09,0,0,1-.08-.08v-.68a.08.08,0,0,1,.08-.09.09.09,0,0,1,.09.08v.68a.09.09,0,0,1-.08.09Zm113-2h0a.09.09,0,0,1-.08-.09v-.68a.09.09,0,0,1,.09-.08.08.08,0,0,1,.08.09v.68a.09.09,0,0,1-.09.05ZM360.94,377a.08.08,0,0,1-.09-.08v-.68a.09.09,0,0,1,.09-.08.08.08,0,0,1,.08.08v.67a.08.08,0,0,1-.08.09Zm113.12-2h0a.09.09,0,0,1-.08-.09v-.67a.09.09,0,0,1,.09-.09h0a.09.09,0,0,1,.08.09v.68a.09.09,0,0,1-.09,0Zm-113.22-.22a.09.09,0,0,1-.08-.09v-.67a.08.08,0,0,1,.08-.09.09.09,0,0,1,.09.08v.68a.11.11,0,0,1-.08.09Zm113.25-2a.09.09,0,0,1-.08-.08v-.68a.09.09,0,0,1,.09-.09h0a.09.09,0,0,1,.08.09v.68a.09.09,0,0,1-.09-.04Zm-113.34-.22a.09.09,0,0,1-.09-.08v-.68a.09.09,0,0,1,.17,0v.68a.08.08,0,0,1-.08.09Zm113.34-2a.07.07,0,0,1-.08-.08c0-.23,0-.45,0-.68a.08.08,0,0,1,.08-.08c.06,0,.09,0,.09.08v.68a.078.078,0,0,1-.08.08Zm-113.44-.22a.07.07,0,0,1-.08-.08v-.68a.078.078,0,0,1,.08-.08.09.09,0,0,1,.09.08v.67a.08.08,0,0,1-.08.09Zm113.4-2a.09.09,0,0,1-.08-.09v-.67a.09.09,0,0,1,.08-.09h0a.09.09,0,0,1,.08.08v.68a.1.1,0,0,1-.08.09Zm-113.5-.22a.09.09,0,0,1-.08-.09v-.67a.09.09,0,0,1,.08-.09.08.08,0,0,1,.09.08v.68a.11.11,0,0,1-.08.09Zm113.43-2a.09.09,0,0,1-.08-.08v-.68a.187.187,0,0,1,.1-.36.11.11,0,0,1,.09.08v.68a.09.09,0,0,1-.09.09Zm-113.52-.22a.1.1,0,0,1-.09-.08v-.68c0-.05,0-.08.09-.09a.08.08,0,0,1,.08.08v.68a.08.08,0,0,1-.08.09Zm113.41-2a.08.08,0,0,1-.08-.08v-.67a.07.07,0,0,1,.07-.09.08.08,0,0,1,.09.08c0,.22,0,.45,0,.67A.09.09,0,0,1,473.87,363.9Zm-113.51-.22a.08.08,0,0,1-.08-.08v-.68a.085.085,0,0,1,.17,0v.67a.09.09,0,0,1-.08.09Zm113.36-2a.08.08,0,0,1-.08-.08l-.06-.67a.08.08,0,0,1,.08-.09.07.07,0,0,1,.09.07l.06.68a.09.09,0,0,1-.08.09Zm-113.45-.22a.09.09,0,0,1-.09-.08v-.68a.09.09,0,0,1,.08-.09.08.08,0,0,1,.09.08v.68A.09.09,0,0,1,360.27,361.46Zm113.26-2a.09.09,0,0,1-.09-.08l-.06-.67a.07.07,0,0,1,.07-.09.09.09,0,0,1,.1.07l.06.68s0,.08-.07.09Zm-113.36-.23a.09.09,0,0,1-.08-.08v-.68a.09.09,0,0,1,.08-.09.1.1,0,0,1,.09.08v.68A.09.09,0,0,1,360.17,359.23Zm113.12-2a.08.08,0,0,1-.08-.07c0-.23-.06-.45-.08-.67a.08.08,0,0,1,.07-.1.09.09,0,0,1,.09.08l.09.67a.08.08,0,0,1-.08.09Zm-113.21-.24a.08.08,0,0,1-.09-.08v-.67a.09.09,0,0,1,.08-.09.08.08,0,0,1,.09.08v.67a.08.08,0,0,1-.08.09Zm1.44-.69a.09.09,0,0,1-.08-.08.08.08,0,0,1,.08-.09h.68a.08.08,0,0,1,.08.09.07.07,0,0,1-.08.08Zm2.26,0a.085.085,0,0,1,0-.17h.68c.05,0,.08,0,.08.09a.08.08,0,0,1-.08.08Zm2.26,0a.09.09,0,0,1-.09-.08.08.08,0,0,1,.09-.08h.68a.078.078,0,0,1,.08.08.09.09,0,0,1-.08.09Zm2.26,0a.085.085,0,1,1,0-.17h.7a.085.085,0,0,1,.01.17Zm2.26,0a.085.085,0,1,1,0-.17h.67c.06,0,.09,0,.09.09a.09.09,0,0,1-.09.08Zm2.25,0a.08.08,0,0,1,0-.16h.68a.085.085,0,1,1,0,.17h-.68Zm2.26,0a.085.085,0,0,1,0-.17h.68a.09.09,0,0,1,.09.08.08.08,0,0,1-.09.08Zm2.26,0a.09.09,0,0,1-.08-.09.08.08,0,0,1,.08-.08H378a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1,0-.16h.68a.09.09,0,0,1,.08.08.08.08,0,0,1-.08.09Zm2.26,0a.085.085,0,1,1,0-.17h.68a.078.078,0,0,1,.08.08.08.08,0,0,1-.08.08Zm2.26,0a.085.085,0,1,1,0-.17h.67a.088.088,0,0,1,.09.09.09.09,0,0,1-.08.08Zm2.26,0a.09.09,0,0,1-.09-.09.08.08,0,0,1,.08-.08H387s.09,0,.09.08a.09.09,0,0,1-.09.09Zm2.25,0a.085.085,0,0,1,0-.17h.68a.08.08,0,1,1,0,.16h-.68Zm2.26,0a.085.085,0,0,1,0-.17h.68a.082.082,0,0,1,.08.09c0,.09,0,.08-.08.08Zm2.26,0a.08.08,0,0,1-.08-.09.07.07,0,0,1,.08-.08h.68a.078.078,0,0,1,.08.08.08.08,0,0,1-.08.09Zm2.26,0a.085.085,0,0,1,0-.17h.68a.078.078,0,0,1,.08.08.08.08,0,0,1-.08.08Zm2.26,0a.085.085,0,1,1,0-.17h.67a.085.085,0,0,1,.01.17Zm2.26,0a.09.09,0,0,1-.09-.09.08.08,0,0,1,.09-.08h.67a.08.08,0,0,1,.09.08.09.09,0,0,1-.08.09Zm2.26,0a.09.09,0,0,1,0-.17h.68a.08.08,0,0,1,.09.08c0,.05,0,.08-.09.09Zm2.25,0a.085.085,0,0,1,0-.17h.68a.085.085,0,1,1,0,.17Zm2.26,0a.09.09,0,0,1-.08-.09.08.08,0,0,1,.08-.08h.68a.085.085,0,0,1,0,.17Zm2.26,0a.085.085,0,0,1,0-.17h.68a.08.08,0,0,1,.08.08.09.09,0,0,1-.08.09Zm2.26,0a.1.1,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.085.085,0,1,1,0-.17h.68a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.08.08,0,0,1,.09.08.09.09,0,0,1-.09.09Zm2.25,0a.085.085,0,0,1,0-.17h.68a.1.1,0,0,1,.09.09.09.09,0,0,1-.09.08H418Zm2.26,0a.085.085,0,0,1,0-.17h.68a.085.085,0,1,1,0,.17Zm2.26,0a.085.085,0,0,1,0-.17h.68a.078.078,0,0,1,.08.08.08.08,0,0,1-.08.09Zm2.26,0a.085.085,0,0,1,0-.17h.68a.09.09,0,0,1,.08.09.08.08,0,0,1-.08.08Zm2.26,0a.085.085,0,1,1,0-.17h.68a.078.078,0,0,1,.08.08.09.09,0,0,1-.08.09Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09H430a.08.08,0,0,1,.09.08.09.09,0,0,1-.08.09Zm2.26,0a.09.09,0,0,1,0-.17h.68a.085.085,0,1,1,0,.17Zm2.25,0a.085.085,0,0,1,0-.17h.68a.08.08,0,0,1,.09.08.09.09,0,0,1-.09.09Zm2.26,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.26,0a.09.09,0,0,1-.08-.08.08.08,0,0,1,.08-.09H439a.085.085,0,0,1,0,.17Zm2.26,0a.08.08,0,0,1-.08-.09.078.078,0,0,1,.08-.08h.68a.09.09,0,0,1,.08.08.08.08,0,0,1-.08.09Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.08.08,0,0,1,.08.08.09.09,0,0,1-.08.09Zm2.26,0A.652.652,0,0,1,445,355a.09.09,0,0,1,.09-.09h.67a.085.085,0,1,1,.01.17Zm2.26,0a.085.085,0,1,1-.01-.17H448a.085.085,0,1,1,0,.17Zm2.25,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68a.08.08,0,0,1,.09.08.09.09,0,0,1-.09.09Zm2.26,0a.09.09,0,0,1-.08-.08.08.08,0,0,1,.08-.09h.68a.08.08,0,0,1,.08.09.078.078,0,0,1-.08.08Zm2.26,0a.085.085,0,0,1,0-.17h.68a.078.078,0,0,1,.08.08.08.08,0,0,1-.08.09Zm2.26,0a.085.085,0,1,1,0-.17h.68a.078.078,0,0,1,.08.08.09.09,0,0,1-.08.09Zm2.26,0a.085.085,0,1,1,0-.17h.67a.085.085,0,0,1,.01.17Zm2.26,0a.085.085,0,1,1,0-.17h.67a.08.08,0,0,1,.09.08.09.09,0,0,1-.09.09Zm2.25,0a.08.08,0,0,1-.08-.08.1.1,0,0,1,.08-.09h.68a.08.08,0,0,1,.09.08.09.09,0,0,1-.09.09Zm2.26,0a.085.085,0,0,1,0-.17h.68a.085.085,0,1,1,0,.17Zm2.26,0a.09.09,0,0,1-.08-.09.08.08,0,0,1,.08-.08h.68a.082.082,0,0,1,.08.09.08.08,0,0,1-.08.08Zm2.26,0a.07.07,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68c.05,0,.08,0,.08.08a.08.08,0,0,1-.08.09Zm2.26,0a.085.085,0,1,1,0-.17h.68a.085.085,0,0,1,0,.17Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_36"
                        data-name="Path 36"
                        d="M384.48,327.05l.25-3a2.38,2.38,0,0,1,1.76-1.39c2.93-.49,10.21-1.39,13.74,1.19l.56,3.53Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_37"
                        data-name="Path 37"
                        d="M393.63,324a4.27,4.27,0,0,1-2,0,1.85,1.85,0,0,1-1.42-1.77l-.09-9.5,4.83-.05.1,9.5a1.84,1.84,0,0,1-1.42,1.82Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_38"
                        data-name="Path 38"
                        d="M431.33,326.57l.26-3a2.32,2.32,0,0,1,1.75-1.38c2.93-.5,10.21-1.39,13.74,1.19l.56,3.52Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_39"
                        data-name="Path 39"
                        d="M440.48,323.56a4.27,4.27,0,0,1-2,0,1.82,1.82,0,0,1-1.41-1.76l-.11-10.51,4.84-.05.1,10.5A1.84,1.84,0,0,1,440.48,323.56Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_40"
                        data-name="Path 40"
                        d="M389.61,315.12l52-2.25a2.52,2.52,0,0,0,2.38-2.09,21.14,21.14,0,0,0,.09-6.59,6,6,0,0,0-5.87-5c-9.7-.13-34.41.13-48,5.66a4.75,4.75,0,0,0-2.84,3.32,11.661,11.661,0,0,0-.07,5.29A2.23,2.23,0,0,0,389.61,315.12Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_41"
                        data-name="Path 41"
                        d="M388.68,312.43a.24.24,0,0,1-.23-.2,12.69,12.69,0,0,1,.28-3.93,4.34,4.34,0,0,1,2.92-3,57,57,0,0,1,12.93-2.55.22.22,0,0,1,.24.21.24.24,0,0,1-.22.24,56.331,56.331,0,0,0-12.82,2.54,3.88,3.88,0,0,0-2.62,2.71,12,12,0,0,0-.26,3.76.21.21,0,0,1-.2.24Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_42"
                        data-name="Path 42"
                        d="M360.33,326.12c16.81-.39,89.5-1.9,110.65.43a4.3,4.3,0,0,1,3.73,3.29c1.3,5.63,4,18.71,3.79,31.7a3.77,3.77,0,0,1-3.05,3.62l-48.11,9.62-17.13.18-51.47-9.68a4,4,0,0,1-3.27-3.7c-.4-6.53-1.08-21.86.58-31.75a4.45,4.45,0,0,1,4.28-3.71Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_43"
                        data-name="Path 43"
                        d="M410.58,370.88h0l-.66-.12a.09.09,0,0,1-.07-.1.08.08,0,0,1,.1-.07l.67.13a.08.08,0,0,1,.06.1S410.62,370.88,410.58,370.88Zm1.14,0a.07.07,0,0,1-.08-.08.08.08,0,0,1,.08-.09h.68a.085.085,0,0,1,0,.17Zm2.26,0a.085.085,0,1,1,0-.17h.68a.082.082,0,0,1,.08.09.09.09,0,0,1-.08.08Zm2.26,0a.085.085,0,1,1,0-.17h.67s.09,0,.09.08a.09.09,0,0,1-.08.09Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.08-.09h.68a.085.085,0,1,1,0,.17Zm2.25,0a.085.085,0,0,1,0-.17h.68a.088.088,0,0,1,.09.09.09.09,0,0,1-.09.08Zm2.26,0a.09.09,0,0,1-.08-.09.08.08,0,0,1,.08-.08h.68a.078.078,0,0,1,.08.08.08.08,0,0,1-.08.09Zm2.26,0a.07.07,0,0,1-.08-.08.08.08,0,0,1,.08-.09H426a.085.085,0,0,1,0,.17Zm2.25-.14a.081.081,0,1,1-.02-.16l.67-.14a.07.07,0,0,1,.09.07.08.08,0,0,1-.06.1l-.67.13Zm-19.16-.12h0l-.66-.13a.08.08,0,0,1-.07-.1.09.09,0,0,1,.1-.07l.67.13a.043.043,0,1,1-.04.02Zm21.37-.32a.08.08,0,0,1-.08-.07.09.09,0,0,1,.07-.1l.66-.13a.08.08,0,0,1,.1.07.09.09,0,0,1-.07.1l-.66.13Zm-23.59-.1h0l-.67-.13a.08.08,0,1,1,0-.16l.67.12a.1.1,0,1,1,0,.02Zm25.81-.34a.1.1,0,0,1-.09-.07.08.08,0,0,1,.07-.1l.66-.13c.05,0,.1,0,.1.06s0,.1-.06.1l-.67.14Zm-28-.08h0l-.67-.12a.09.09,0,0,1-.07-.1.08.08,0,0,1,.1-.07l.67.12a.09.09,0,0,1,.06.1.08.08,0,0,1-.12-.08Zm30.24-.36a.085.085,0,0,1-.01-.17l.66-.13a.08.08,0,0,1,0,.16l-.66.13Zm-32.46-.06h0l-.67-.12a.09.09,0,0,1,0-.17l.67.13s.07.05.06.1-.05-.09-.09-.09Zm34.68-.39a.09.09,0,0,1-.09-.06.08.08,0,0,1,.07-.1l.66-.14a.08.08,0,0,1,.1.07.09.09,0,0,1-.06.1l-.67.13Zm-36.9,0h0l-.67-.13a.08.08,0,0,1-.07-.1.1.1,0,0,1,.1-.07l.67.13a.054.054,0,1,1-.06,0Zm39.11-.42a.08.08,0,0,1-.08-.07.09.09,0,0,1,.06-.1l.67-.13a.08.08,0,0,1,.1.07.09.09,0,0,1-.07.1l-.66.13Zm-41.33,0h0l-.67-.13a.08.08,0,0,1-.07-.1.09.09,0,0,1,.1-.06l.67.12a.048.048,0,1,1-.06,0ZM395,368h0l-.67-.12a.09.09,0,0,1,0-.17l.67.12a.11.11,0,0,1,.07.1.1.1,0,0,1-.07.07Zm45.77,0a.1.1,0,0,1-.09-.07.08.08,0,0,1,.07-.1l.66-.13a.08.08,0,0,1,0,.16l-.67.14Zm-48-.4h0l-.67-.12a.1.1,0,0,1-.07-.1.09.09,0,0,1,.1-.07l.67.13a.1.1,0,0,1,.07.1.09.09,0,0,1-.05,0Zm50.2,0a.086.086,0,0,1-.02-.17l.67-.14a.11.11,0,0,1,.1.07.08.08,0,0,1-.07.1l-.66.13Zm-52.42-.37h0l-.67-.13a.086.086,0,0,1,.03-.17l.67.13a.089.089,0,1,1,.02.07Zm54.64-.08a.1.1,0,0,1-.09-.07.09.09,0,0,1,.07-.1l.66-.13a.08.08,0,0,1,.1.07.09.09,0,0,1-.06.1l-.67.13Zm-56.86-.34h0l-.67-.13a.1.1,0,0,1-.07-.1.09.09,0,0,1,.1-.06l.67.12a.09.09,0,0,1,.07.1.1.1,0,0,1-.05-.03Zm59.07-.1a.08.08,0,0,1-.08-.07.09.09,0,0,1,.06-.1l.67-.13a.09.09,0,0,1,0,.17l-.66.13Zm-61.29-.32h0l-.67-.12a.11.11,0,0,1-.07-.1.09.09,0,0,1,.1-.07l.67.12a.09.09,0,0,1,.07.1.1.1,0,0,1-.05-.03Zm63.51-.12a.1.1,0,0,1-.09-.07.08.08,0,0,1,.07-.1l.66-.13a.08.08,0,0,1,0,.16l-.67.14Zm-65.73-.3h0l-.67-.12a.11.11,0,0,1-.07-.1.09.09,0,0,1,.1-.07l.67.13a.08.08,0,0,1,.07.1.09.09,0,0,1-.05-.04Zm67.94-.15a.081.081,0,0,1-.02-.16l.67-.14a.1.1,0,0,1,.1.07.08.08,0,0,1-.07.1l-.66.13Zm-70.16-.26h0l-.67-.13a.086.086,0,1,1,.03-.17l.67.13a.08.08,0,0,1,.07.1.1.1,0,0,1-.05-.03Zm72.37-.18a.086.086,0,0,1-.01-.17l.66-.13a.08.08,0,0,1,.1.07.09.09,0,0,1-.06.1l-.67.13ZM379.5,365h0l-.67-.13a.08.08,0,0,1-.06-.1.07.07,0,0,1,.09-.06l.67.12a.08.08,0,0,1,.07.1A.1.1,0,0,1,379.5,365Zm76.81-.2a.086.086,0,0,1-.02-.17l.67-.13a.09.09,0,0,1,.1.06.08.08,0,0,1-.07.1l-.66.14Zm-79-.22h0l-.67-.12a.09.09,0,0,1-.06-.1.07.07,0,0,1,.09-.07l.67.12a.09.09,0,0,1,.07.1.1.1,0,0,1-.13.11Zm81.24-.22a.09.09,0,0,1-.08-.07.08.08,0,0,1,.07-.1l.66-.13a.08.08,0,1,1,0,.16l-.67.13Zm-83.45-.2h0l-.67-.12a.09.09,0,0,1-.06-.1.07.07,0,0,1,.09-.07l.67.13a.08.08,0,0,1,.07.1.082.082,0,1,1-.13.1Zm85.67-.25s-.08,0-.08-.06,0-.1.06-.1l.67-.14a.09.09,0,0,1,.1.07.08.08,0,0,1-.07.1l-.66.13Zm-87.89-.16h0l-.67-.13a.087.087,0,0,1,.04-.17l.66.13a.08.08,0,0,1,.07.1.085.085,0,0,1-.13.11Zm90.1-.28a.08.08,0,0,1-.08-.07.09.09,0,0,1,.07-.1l.66-.13a.08.08,0,0,1,.1.07.09.09,0,0,1-.06.1l-.67.13Zm-92.32-.14h0l-.67-.13a.08.08,0,1,1,0-.16l.66.12a.106.106,0,0,1-.02.21Zm94.54-.3a.086.086,0,0,1-.02-.17l.67-.13a.09.09,0,0,1,.1.06.08.08,0,0,1-.07.1l-.66.14ZM368.41,363h0l-.67-.12a.09.09,0,0,1-.06-.1.08.08,0,0,1,.1-.07l.66.12a.09.09,0,0,1,.07.1.08.08,0,0,1-.1.07Zm99-.32a.085.085,0,0,1-.01-.17l.66-.14a.1.1,0,0,1,.1.07.08.08,0,0,1-.06.1l-.67.13Zm-101.19-.1h0l-.67-.12a.09.09,0,0,1-.06-.1.08.08,0,0,1,.1-.07l.66.13a.07.07,0,1,1-.06.11Zm103.41-.35a.081.081,0,0,1-.02-.16l.67-.14a.09.09,0,1,1,0,.17l-.66.13ZM364,362.12h0l-.67-.13a.08.08,0,0,1-.06-.1.09.09,0,0,1,.1-.07l.66.13a.086.086,0,1,1-.03.17Zm107.84-.38a.08.08,0,0,1-.08-.07.09.09,0,0,1,.07-.1l.66-.13a.08.08,0,0,1,.1.07.09.09,0,0,1-.07.1l-.66.13Zm-110.06,0h0l-.66-.13a.08.08,0,1,1,0-.16l.66.12a.07.07,0,1,1-.03.13ZM474,361.3a.086.086,0,0,1-.02-.17l.25-.05v-.29a.09.09,0,0,1,.09-.08h0a.09.09,0,0,1,.08.09v.42l-.38.08Zm-114.43-.08a.09.09,0,0,1-.08-.08v-.68a.08.08,0,0,1,.08-.09.09.09,0,0,1,.09.08v.68a.11.11,0,0,1-.08.09Zm114.74-1.92a.08.08,0,0,1-.08-.08v-.68a.081.081,0,1,1,.16,0c0,.22,0,.45,0,.67a.09.09,0,0,1-.09.09ZM359.48,359a.09.09,0,0,1-.09-.08v-.68a.091.091,0,0,1,.08-.09.11.11,0,0,1,.09.08v.68a.08.08,0,0,1-.08.09Zm114.81-2a.08.08,0,0,1-.09-.08v-.68a.09.09,0,0,1,.09-.08.08.08,0,0,1,.08.08v.67a.08.08,0,0,1-.08.09Zm-114.92-.34a.09.09,0,0,1-.09-.08v-.68a.09.09,0,0,1,.09-.08.07.07,0,0,1,.08.08v.67a.08.08,0,0,1-.08.09Zm114.81-1.91a.09.09,0,0,1-.08-.08c0-.23,0-.45,0-.68,0,0,0-.08.07-.09a.09.09,0,0,1,.09.08c0,.23,0,.45,0,.68a.11.11,0,0,1-.08.09Zm-114.9-.34a.08.08,0,0,1-.08-.09v-.67a.09.09,0,0,1,.08-.09.08.08,0,0,1,.09.08v.68a.091.091,0,0,1-.08.09ZM474,352.54a.09.09,0,0,1-.08-.08l-.06-.68a.09.09,0,0,1,.17,0,3.028,3.028,0,0,0,.05.67.09.09,0,0,1-.07.1Zm-114.82-.35a.09.09,0,0,1-.08-.08v-.68a.09.09,0,0,1,.08-.09h0a.09.09,0,0,1,.08.08v.68a.09.09,0,0,1-.09.09Zm114.63-1.91a.09.09,0,0,1-.09-.07l-.06-.68s0-.08.07-.09a.1.1,0,0,1,.1.08l.06.67a.08.08,0,0,1-.08.09Zm-114.68-.35a.09.09,0,0,1-.08-.08v-.68a.09.09,0,0,1,.08-.09.08.08,0,0,1,.09.09c0,.22,0,.45,0,.67a.09.09,0,0,1-.08.09ZM473.6,348a.09.09,0,0,1-.08-.08,1.926,1.926,0,0,0-.08-.67.1.1,0,0,1,.08-.1.08.08,0,0,1,.09.08,5.106,5.106,0,0,0,.08.67.1.1,0,0,1-.08.1Zm-114.46-.37a.08.08,0,0,1-.08-.08c0-.23,0-.46,0-.68a.09.09,0,0,1,.09-.09h0a.09.09,0,0,1,.08.09v.67a.08.08,0,0,1-.08.09Zm114.19-1.88a.08.08,0,0,1-.08-.07l-.09-.67a.1.1,0,0,1,.08-.1.09.09,0,0,1,.09.08l.09.67a.09.09,0,0,1-.08.09Zm-114.19-.38h0a.08.08,0,0,1-.08-.08v-.68a.085.085,0,0,1,.17,0v.68a.09.09,0,0,1-.09.12ZM473,343.55a.08.08,0,0,1-.08-.07,5.156,5.156,0,0,0-.1-.67.081.081,0,1,1,.16-.02,5.424,5.424,0,0,0,.1.67.07.07,0,0,1-.07.09Zm-113.86-.4h0c-.05,0-.09,0-.08-.08v-.68a.08.08,0,0,1,.09-.08.09.09,0,0,1,.08.08v.68a.09.09,0,0,1-.06.08Zm113.52-1.83a.08.08,0,0,1-.08-.07,3.746,3.746,0,0,0-.11-.67.08.08,0,0,1,.07-.1.1.1,0,0,1,.1.07,5.156,5.156,0,0,0,.1.67.08.08,0,0,1-.07.1Zm-113.46-.43h0a.08.08,0,0,1-.08-.08c0-.23,0-.46,0-.68a.09.09,0,0,1,.09-.08.08.08,0,0,1,.08.09c0,.22,0,.45,0,.67a.08.08,0,0,1-.06.08Zm113.09-1.8a.08.08,0,0,1-.08-.07l-.12-.67a.07.07,0,0,1,.07-.09.09.09,0,0,1,.1.06,3.9,3.9,0,0,0,.11.67.08.08,0,0,1-.07.1Zm-113-.45h0a.09.09,0,0,1-.08-.09v-.68a.08.08,0,0,1,.09-.08.07.07,0,0,1,.07.09v.68a.1.1,0,0,1-.04.08Zm112.59-1.77a.1.1,0,0,1-.09-.07l-.12-.67a.09.09,0,0,1,.06-.1.08.08,0,0,1,.1.07c.05.22.09.44.13.67a.09.09,0,0,1-.07.1Zm-112.44-.49h0a.08.08,0,0,1-.08-.09l.06-.68a.07.07,0,0,1,.09-.07.09.09,0,0,1,.08.09l-.06.67a.08.08,0,0,1-.05.08Zm112-1.73a.08.08,0,0,1-.08-.07,2.867,2.867,0,0,0-.14-.66.08.08,0,0,1,.07-.1.09.09,0,0,1,.1.06,3.336,3.336,0,0,0,.14.67.1.1,0,0,1-.07.1Zm-111.8-.52h0a.09.09,0,0,1-.08-.09,5.25,5.25,0,0,1,.08-.68.08.08,0,0,1,.09-.07.09.09,0,0,1,.08.09,1.982,1.982,0,0,1-.08.68.08.08,0,0,1-.05.07ZM471,332.44a.1.1,0,0,1-.09-.07c-.05-.23-.1-.45-.14-.66a.082.082,0,1,1,.16-.04l.15.66a.09.09,0,0,1-.07.11Zm-111-.55h0a.08.08,0,0,1-.07-.1,3.87,3.87,0,0,1,.1-.67.07.07,0,0,1,.09-.07.08.08,0,0,1,.07.1,4.018,4.018,0,0,1-.1.67.08.08,0,0,1-.09.07Zm110.11-1.18h0l-.67-.06a.1.1,0,0,1-.08-.1s.05-.08.09-.07l.68.06a.1.1,0,1,1-.07.17Zm-2.25-.2h0l-.67-.05a.09.09,0,0,1-.08-.09.08.08,0,0,1,.09-.08h.68a.07.07,0,0,1,.07.09.1.1,0,1,1-.14.13Zm-2.25-.16h0l-.67-.05a.08.08,0,0,1-.08-.09.09.09,0,0,1,.09-.08l.67.05a.08.08,0,0,1,.08.09.09.09,0,0,1-.14.08Zm-104.58,0a.08.08,0,1,1,0-.16h.68a.11.11,0,0,1,.09.08.09.09,0,0,1-.09.09Zm2.26,0a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68c.05,0,.08,0,.09.08a.09.09,0,0,1-.09.09Zm2.26-.05a.08.08,0,1,1,0-.16h.68a.09.09,0,0,1,.08.08.08.08,0,0,1-.08.09Zm97.8,0h-.68a.11.11,0,0,1-.08-.09.08.08,0,0,1,.09-.08h.68a.09.09,0,1,1,0,.17Zm-95.54,0a.09.09,0,0,1-.08-.09.08.08,0,0,1,.08-.08h.68a.09.09,0,0,1,.08.09.08.08,0,0,1-.08.08Zm2.26-.05a.08.08,0,0,1-.08-.08A.085.085,0,1,1,370,330h.68a.09.09,0,0,1,.08.08.08.08,0,0,1-.08.09Zm2.26,0a.08.08,0,0,1-.08-.09.078.078,0,0,1,.08-.08h.68a.1.1,0,0,1,.08.09.08.08,0,0,1-.08.08Zm88.77,0h-.67a.08.08,0,0,1-.08-.09.07.07,0,0,1,.08-.08h.68a.08.08,0,0,1,.08.09.09.09,0,0,1-.14-.07Zm-86.51,0a.09.09,0,0,1-.09-.08c0-.05,0-.08.09-.09h.67a.09.09,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.085.085,0,0,1,0,.17Zm82,0h-.68a.09.09,0,1,1,0-.17h.67s.09.05.08.09a.107.107,0,0,1-.13-.17Zm-79.73,0a.085.085,0,1,1,0-.17h.67a.09.09,0,1,1,0,.17Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.08-.09H382c.05,0,.09,0,.09.08a.09.09,0,0,1-.08.09Zm75.21,0h-.68a.09.09,0,0,1-.08-.09c0-.05,0-.08.09-.08h.68a.09.09,0,0,1,.08.09.146.146,0,0,1-.15-.25Zm-73,0a.08.08,0,1,1,0-.16h.68a.085.085,0,1,1,0,.17h-.68Zm2.26,0a.085.085,0,0,1,0-.17h.68a.085.085,0,1,1,0,.17Zm68.45,0h-.67a.09.09,0,0,1-.09-.09.1.1,0,0,1,.09-.08h.68a.09.09,0,0,1,.08.09.169.169,0,1,1-.11-.32Zm-66.19,0a.08.08,0,0,1-.08-.08.1.1,0,0,1,.08-.09h.68a.11.11,0,0,1,.09.09.09.09,0,0,1-.09.08Zm2.26,0a.09.09,0,0,1-.08-.08.08.08,0,0,1,.08-.09H391a.1.1,0,0,1,.08.09.08.08,0,0,1-.08.08Zm61.67,0h-.68s-.09,0-.08-.08a.09.09,0,0,1,.08-.09h.68a.08.08,0,0,1,.08.09.2.2,0,0,1-.12-.38Zm-59.41,0a.085.085,0,0,1,0-.17h.68a.09.09,0,0,1,.08.08.08.08,0,0,1-.08.09Zm2.26,0a.085.085,0,0,1,0-.17h.68a.09.09,0,0,1,.08.08.08.08,0,0,1-.08.09Zm54.89,0h-.68a.08.08,0,0,1-.08-.08.09.09,0,0,1,.08-.09h.68c.05,0,.09,0,.08.08a.216.216,0,1,1-.1-.42Zm-52.63,0a.085.085,0,1,1,0-.17h.68a.08.08,0,0,1,.08.09.09.09,0,0,1-.08.08Zm50.37,0h-.68a.09.09,0,0,1-.08-.09.08.08,0,0,1,.09-.08h.67a.09.09,0,0,1,.09.09.246.246,0,1,1-.11-.48Zm-48.11,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.07.07,0,0,1,.09.08.09.09,0,0,1-.08.09Zm2.26,0a.085.085,0,1,1,0-.17h.67c.05,0,.09,0,.09.09a.09.09,0,0,1-.09.08Zm43.59,0h-.68a.085.085,0,0,1,.01-.17h.67a.09.09,0,0,1,.09.09.266.266,0,0,1-.11-.52Zm-41.33,0a.08.08,0,1,1,0-.16h.68a.08.08,0,0,1,.08.08.09.09,0,0,1-.08.09Zm39.07,0h-.67a.085.085,0,1,1,0-.17H443a.09.09,0,1,1,0,.17Zm-36.81,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.68a.078.078,0,0,1,.08.08.09.09,0,0,1-.08.09Zm2.26,0a.08.08,0,0,1-.09-.08.09.09,0,0,1,.09-.09h.67a.08.08,0,0,1,.09.08.09.09,0,0,1-.08.09Zm32.3,0h-.68a.09.09,0,0,1-.09-.09.08.08,0,0,1,.09-.08h.68a.09.09,0,0,1,.08.09.294.294,0,1,1-.1-.58Zm-30,0a.085.085,0,1,1,0-.17h.66a.1.1,0,0,1,.09.09.08.08,0,0,1-.08.08Zm27.78,0h-.68c-.05,0-.09,0-.08-.08s0-.09.08-.08h.68a.09.09,0,0,1,.08.09.313.313,0,1,1-.14-.61Zm-25.51,0v-.17h.66a.08.08,0,0,1,.09.08.09.09,0,0,1-.09.09Zm23.25,0h-.68a.085.085,0,0,1,0-.17h.68a.08.08,0,0,1,.08.09.318.318,0,0,1-.14-.62Zm-21,0v-.17h.66a.09.09,0,0,1,.09.09.08.08,0,0,1-.09.08Zm18.73,0h-.68a.09.09,0,0,1-.08-.09.08.08,0,0,1,.08-.08H434a.08.08,0,0,1,.08.08.313.313,0,1,1-.08-.62Zm-16.49,0a.09.09,0,0,1-.08-.09.08.08,0,0,1,.08-.08h.68a.08.08,0,0,1,.08.09.07.07,0,0,1-.08.08Zm14.23,0H431a.09.09,0,0,1-.08-.09.08.08,0,0,1,.08-.08h.68a.09.09,0,0,1,.09.08.318.318,0,1,1-.08-.63Zm-12,0v-.17h.67a.08.08,0,0,1,.08.08.09.09,0,0,1-.08.09Zm2.26,0v-.17h.67a.085.085,0,0,1,0,.17Zm7.44,0h-.68a.085.085,0,1,1,.01-.17h.67a.09.09,0,0,1,.09.09.329.329,0,1,1-.1-.65Zm-5.19,0a.085.085,0,1,1,0-.17h.67a.09.09,0,1,1,0,.17Zm2.93,0h-.67a.085.085,0,1,1,0-.17h.67a.09.09,0,0,1,.09.08.324.324,0,1,1-.1-.64Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_44"
                        data-name="Path 44"
                        d="M425.8,382l-15,.15a3.87,3.87,0,0,1-3.89-3.36L405,364.36a3.86,3.86,0,0,1,3.81-4.36l18-.19a3.87,3.87,0,0,1,3.91,4.17l-1.14,14.44A3.88,3.88,0,0,1,425.8,382Z"
                        fill="#636464"
                    />
                    <path
                        id="Path_45"
                        data-name="Path 45"
                        d="M423.93,379.35l-11.42.12a3,3,0,0,1-3-2.56l-1.43-11a3,3,0,0,1,2.9-3.32l13.71-.14a2.94,2.94,0,0,1,3,3.17l-.87,11a2.94,2.94,0,0,1-2.89,2.73Z"
                        fill="#d6d6d6"
                        opacity="0.5"
                    />
                    <rect
                        id="Rectangle_1"
                        data-name="Rectangle 1"
                        width="70.89"
                        height="33.06"
                        transform="translate(348.595 163.721) rotate(-68.9)"
                        fill="#707272"
                    />
                    <path
                        id="Path_46"
                        data-name="Path 46"
                        d="M379.2,103.73l17.64,6.81a3,3,0,0,0,1.87,3.72l.17.07-20.6,53.38-.17-.07a2.94,2.94,0,0,0-3.86,1.5h0L357,162.52c.94-2.43-.59-3.28-2.16-3.89h-.07l20.6-53.39h.06a2.9,2.9,0,0,0,3.77-1.51Z"
                        fill="#f4f5f6"
                    />
                    <circle
                        id="Ellipse_1"
                        data-name="Ellipse 1"
                        cx="10.4"
                        cy="10.4"
                        r="10.4"
                        transform="translate(362.053 138.14) rotate(-51.37)"
                        fill="#707272"
                    />
                    <path
                        id="Path_47"
                        data-name="Path 47"
                        d="M382.86,140l-1-.4a9,9,0,0,1-1.73,2.64.65.65,0,0,1-.83.06l-.85-.63a.64.64,0,0,1-.08-1,7.36,7.36,0,0,0,1.58-2.44c.4-1,.35-1.93-.37-2.21s-1.26.2-2.19,1.48c-1.35,1.83-2.81,3-4.6,2.26-1.63-.63-2.41-2.29-1.95-4.48l-1-.4a.64.64,0,0,1-.37-.83l.23-.6a.65.65,0,0,1,.83-.37l.92.36a8,8,0,0,1,1.29-2.12.63.63,0,0,1,.86-.1l.79.58a.63.63,0,0,1,.1.94,6.879,6.879,0,0,0-1.27,2.09c-.47,1.22-.1,1.76.36,1.94s1.22-.37,2.33-1.77c1.55-2,2.86-2.59,4.55-1.94s2.51,2.3,2,4.66l1.14.45a.64.64,0,0,1,.37.83l-.23.6a.65.65,0,0,1-.88.4Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_48"
                        data-name="Path 48"
                        d="M357,165.14h-.06l-5.78-2.23a.13.13,0,0,1-.1-.09.15.15,0,0,1,0-.13l6.3-16.33a.17.17,0,0,1,.22-.1.18.18,0,0,1,.1.22l-6.24,16.18,5.62,2.17a.17.17,0,0,1-.06.33Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_49"
                        data-name="Path 49"
                        d="M396.25,127h-.06a.17.17,0,0,1-.1-.22l6.17-16-6-2.32a.18.18,0,0,1-.1-.22.16.16,0,0,1,.22-.1l6.19,2.39a.17.17,0,0,1,.09.22l-6.22,16.13A.17.17,0,0,1,396.25,127Z"
                        fill="#f4f5f6"
                    />
                    <rect
                        id="Rectangle_2"
                        data-name="Rectangle 2"
                        width="70.89"
                        height="33.27"
                        transform="translate(347.023 160.546) rotate(-68.9)"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_50"
                        data-name="Path 50"
                        d="M377.68,100.59l17.65,6.81a3,3,0,0,0,1.94,3.74,1.74,1.74,0,0,1,.24.08l-20.6,53.38-.23-.09a3,3,0,0,0-3.9,1.48h-.07l-17.25-6.65c.94-2.44-.62-3.31-2.19-3.92h-.09l20.59-53.38a.25.25,0,0,0,.09,0,2.9,2.9,0,0,0,3.82-1.45Z"
                        fill="#f4f5f6"
                    />
                    <circle
                        id="Ellipse_2"
                        data-name="Ellipse 2"
                        cx="10.4"
                        cy="10.4"
                        r="10.4"
                        transform="matrix(0.848, -0.53, 0.53, 0.848, 360.864, 130.075)"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_51"
                        data-name="Path 51"
                        d="M381.35,136.87l-1-.39a9,9,0,0,1-1.74,2.63.61.61,0,0,1-.82.06l-.86-.63a.64.64,0,0,1-.08-1,7.64,7.64,0,0,0,1.59-2.44c.39-1,.34-1.94-.37-2.21s-1.26.19-2.2,1.48c-1.35,1.82-2.8,3-4.6,2.25-1.62-.62-2.41-2.29-1.94-4.48l-1-.39a.65.65,0,0,1-.37-.83l.24-.6a.64.64,0,0,1,.8-.32l.92.36a8,8,0,0,1,1.29-2.13.63.63,0,0,1,.86-.09l.79.58a.64.64,0,0,1,.1.94,6.62,6.62,0,0,0-1.27,2.08c-.47,1.22-.1,1.77.35,1.94s1.23-.37,2.33-1.77c1.56-2,2.86-2.58,4.56-1.93,1.55.6,2.5,2.29,2,4.66l1.15.44a.64.64,0,0,1,.36.83l-.23.6a.64.64,0,0,1-.86.36Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_52"
                        data-name="Path 52"
                        d="M355.67,161.84h-.06l-6-2.31a.17.17,0,0,1-.1-.22l6.23-16.13a.166.166,0,1,1,.31.12l-6.16,16,5.83,2.25a.147.147,0,0,1-.05.29Z"
                        fill="#fff"
                        opacity="0.72"
                    />
                    <path
                        id="Path_53"
                        data-name="Path 53"
                        d="M394.68,123.86h-.06a.17.17,0,0,1-.1-.22l6.16-16-5.82-2.25a.16.16,0,0,1-.1-.22.17.17,0,0,1,.22-.09l6,2.31a.16.16,0,0,1,.1.22l-6.22,16.12A.17.17,0,0,1,394.68,123.86Z"
                        fill="#fff"
                    />
                    <rect
                        id="Rectangle_3"
                        data-name="Rectangle 3"
                        width="70.89"
                        height="33.27"
                        transform="translate(338.916 147.956) rotate(-51.35)"
                        fill="#707272"
                    />
                    <path
                        id="Path_54"
                        data-name="Path 54"
                        d="M386.27,100.05,401,111.86a3,3,0,0,0,.69,4.15l.19.15-35.74,44.7c-.17-.14-.14-.13-.18-.16a3,3,0,0,0-4.15.24h-.06l-14.4-11.54c1.63-2,.39-3.34-.93-4.39h-.11l35.74-44.7s.05,0,.09.07a2.94,2.94,0,0,0,4.13-.33Z"
                        fill="#f4f5f6"
                    />
                    <circle
                        id="Ellipse_3"
                        data-name="Ellipse 3"
                        cx="10.4"
                        cy="10.4"
                        r="10.4"
                        transform="translate(361.905 122.189) rotate(-10.2)"
                        fill="#707272"
                    />
                    <path
                        id="Path_55"
                        data-name="Path 55"
                        d="M378.8,135.77l-.86-.68a9.18,9.18,0,0,1-2.44,2,.63.63,0,0,1-.81-.2l-.63-.85a.64.64,0,0,1,.22-.94,7.62,7.62,0,0,0,2.25-1.85c.69-.87.91-1.74.31-2.22s-1.26-.2-2.54.75c-1.84,1.33-3.56,2-5.07.76s-1.6-2.91-.5-4.86l-.86-.68a.66.66,0,0,1-.1-.91l.41-.5a.64.64,0,0,1,.9-.1l.77.62a8.06,8.06,0,0,1,1.87-1.64.63.63,0,0,1,.85.17l.58.79a.65.65,0,0,1-.19.93,6.73,6.73,0,0,0-1.84,1.6c-.82,1-.63,1.66-.25,2s1.28,0,2.75-1c2.09-1.44,3.51-1.6,4.93-.46s1.7,2.94.5,5l1,.77a.65.65,0,0,1,.1.9l-.41.5a.63.63,0,0,1-.94.1Z"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_56"
                        data-name="Path 56"
                        d="M346.69,152a.14.14,0,0,1-.1,0l-5-4a.15.15,0,0,1,0-.23L352.48,134a.17.17,0,0,1,.24,0,.16.16,0,0,1,0,.24l-10.83,13.54,4.88,3.9a.16.16,0,0,1,0,.23A.17.17,0,0,1,346.69,152Z"
                        fill="#fff"
                        opacity="0.72"
                    />
                    <path
                        id="Path_57"
                        data-name="Path 57"
                        d="M395.48,127.35a.2.2,0,0,1-.11,0,.17.17,0,0,1,0-.24L406,113.71l-4.87-3.9a.171.171,0,1,1,.21-.27l5,4a.17.17,0,0,1,.06.11.19.19,0,0,1,0,.13l-10.8,13.5a.16.16,0,0,1-.12.07Z"
                        fill="#fff"
                        opacity="0.72"
                    />
                    <path
                        id="Path_58"
                        data-name="Path 58"
                        d="M363.31,145.46a2.95,2.95,0,1,1-4.14.46A3,3,0,0,1,363.31,145.46Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_59"
                        data-name="Path 59"
                        d="M391,110.85a2.95,2.95,0,1,1-4.14.46,3,3,0,0,1,4.14-.46Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_4"
                        data-name="Ellipse 4"
                        cx="8.86"
                        cy="8.86"
                        r="8.86"
                        transform="translate(289.487 162.887) rotate(-73.18)"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_5"
                        data-name="Ellipse 5"
                        cx="8.57"
                        cy="8.57"
                        r="8.57"
                        transform="translate(289.006 153.23) rotate(-27.13)"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_60"
                        data-name="Path 60"
                        d="M292.86,155.66a.19.19,0,0,1-.13,0,.29.29,0,0,1-.22-.34,8.13,8.13,0,0,1,7.34-6.52.28.28,0,0,1,.31.26.29.29,0,0,1-.26.31,8.079,8.079,0,0,0-1.36.24,7.59,7.59,0,0,0-5.47,5.83.27.27,0,0,1-.21.22Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_6"
                        data-name="Ellipse 6"
                        cx="7.25"
                        cy="7.25"
                        r="7.25"
                        transform="translate(291.576 161.653) rotate(-71.35)"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_61"
                        data-name="Path 61"
                        d="M301.49,162.49l-.2-.76a6.4,6.4,0,0,1-2.27.12.46.46,0,0,1-.38-.46v-.76a.46.46,0,0,1,.52-.45,5.4,5.4,0,0,0,2.09-.12c.76-.21,1.26-.62,1.12-1.15s-.65-.65-1.79-.65c-1.63,0-2.89-.36-3.26-1.7s.31-2.36,1.77-3l-.21-.77a.46.46,0,0,1,.33-.56l.44-.12a.46.46,0,0,1,.57.32l.18.69a6.05,6.05,0,0,1,1.78-.16.46.46,0,0,1,.42.46v.7a.46.46,0,0,1-.5.46,4.76,4.76,0,0,0-1.75.15c-.9.25-1.06.69-1,1s.74.55,2,.59c1.82,0,2.71.56,3.05,1.82s-.26,2.42-1.84,3.13l.23.85a.47.47,0,0,1-.33.57l-.44.12A.47.47,0,0,1,301.49,162.49Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_7"
                        data-name="Ellipse 7"
                        cx="15.43"
                        cy="15.43"
                        r="15.43"
                        transform="translate(301.311 133.748) rotate(-27.65)"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_8"
                        data-name="Ellipse 8"
                        cx="14.91"
                        cy="14.91"
                        r="14.91"
                        transform="translate(305.398 127.406) rotate(-7.5)"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_62"
                        data-name="Path 62"
                        d="M308.72,137.74a.33.33,0,0,1-.14,0,.29.29,0,0,1-.22-.34,14,14,0,0,1,10.09-10.75,14.338,14.338,0,0,1,2.51-.44.29.29,0,0,1,.05.57,13.24,13.24,0,0,0-2.41.43,13.42,13.42,0,0,0-9.68,10.3.27.27,0,0,1-.2.23Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_9"
                        data-name="Ellipse 9"
                        cx="12.62"
                        cy="12.62"
                        r="12.62"
                        transform="translate(304.715 141.686) rotate(-48.98)"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_63"
                        data-name="Path 63"
                        d="M323.79,149.84l-.36-1.33a11.18,11.18,0,0,1-3.93.2.79.79,0,0,1-.67-.79V146.6a.79.79,0,0,1,.91-.79,9.31,9.31,0,0,0,3.63-.21c1.33-.36,2.2-1.08,1.95-2s-1.13-1.12-3.11-1.12c-2.84,0-5-.64-5.67-3-.57-2.1.53-4.12,3.07-5.27l-.36-1.32a.8.8,0,0,1,.56-1l.78-.22a.8.8,0,0,1,1,.57l.33,1.19a10,10,0,0,1,3.09-.27.79.79,0,0,1,.73.79v1.23a.8.8,0,0,1-.88.8,8.151,8.151,0,0,0-3,.26c-1.58.42-1.85,1.2-1.69,1.79s1.28,1,3.5,1c3.17.09,4.72,1,5.31,3.16.55,2-.45,4.22-3.22,5.45l.41,1.49a.81.81,0,0,1-.57,1l-.78.21A.81.81,0,0,1,323.79,149.84Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_10"
                        data-name="Ellipse 10"
                        cx="15.87"
                        cy="15.87"
                        r="15.87"
                        transform="translate(323.837 156.745) rotate(-6.58)"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_11"
                        data-name="Ellipse 11"
                        cx="15.35"
                        cy="15.35"
                        r="15.35"
                        transform="translate(321.814 161.384) rotate(-19.58)"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_64"
                        data-name="Path 64"
                        d="M327.61,168.13a.28.28,0,0,1-.13,0,.29.29,0,0,1-.22-.34,14.37,14.37,0,0,1,10.38-11.05,14.091,14.091,0,0,1,2.58-.46.3.3,0,0,1,.31.26.29.29,0,0,1-.27.31,13.93,13.93,0,0,0-12.44,11,.27.27,0,0,1-.21.28Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_12"
                        data-name="Ellipse 12"
                        cx="12.99"
                        cy="12.99"
                        r="12.99"
                        transform="translate(328.044 183.063) rotate(-86.26)"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_65"
                        data-name="Path 65"
                        d="M343.13,180.58l-.37-1.36a11.64,11.64,0,0,1-4.05.21.82.82,0,0,1-.69-.82v-1.36a.82.82,0,0,1,.94-.81,9.63,9.63,0,0,0,3.73-.22c1.37-.37,2.27-1.11,2-2.06s-1.16-1.16-3.2-1.15c-2.92,0-5.19-.66-5.84-3-.58-2.16.55-4.24,3.17-5.42l-.37-1.37a.83.83,0,0,1,.58-1l.8-.21a.82.82,0,0,1,1,.58l.33,1.22a10.69,10.69,0,0,1,3.18-.28.82.82,0,0,1,.75.82v1.26a.81.81,0,0,1-.9.82,8.67,8.67,0,0,0-3.12.27c-1.62.44-1.9,1.24-1.74,1.84.2.75,1.31,1,3.6,1.07,3.27.09,4.86,1,5.47,3.25.56,2.07-.47,4.34-3.31,5.61l.41,1.52a.83.83,0,0,1-.58,1l-.8.21a.82.82,0,0,1-.99-.62Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_13"
                        data-name="Ellipse 13"
                        cx="11.63"
                        cy="11.63"
                        r="11.63"
                        transform="translate(343.116 133.582) rotate(-3.35)"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_14"
                        data-name="Ellipse 14"
                        cx="11.24"
                        cy="11.24"
                        r="11.24"
                        transform="translate(341.163 137.421) rotate(-18.7)"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_66"
                        data-name="Path 66"
                        d="M345.32,142.69h-.13a.28.28,0,0,1-.23-.33,10.63,10.63,0,0,1,7.66-8.16,11.13,11.13,0,0,1,1.9-.34.29.29,0,0,1,.31.26.28.28,0,0,1-.26.31,11.142,11.142,0,0,0-1.8.32,10.07,10.07,0,0,0-7.25,7.72.28.28,0,0,1-.2.22Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_15"
                        data-name="Ellipse 15"
                        cx="9.52"
                        cy="9.52"
                        r="9.52"
                        transform="matrix(0.781, -0.624, 0.624, 0.781, 342.332, 143.188)"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_67"
                        data-name="Path 67"
                        d="M356.67,151.74l-.28-1a8.46,8.46,0,0,1-3,.15.59.59,0,0,1-.51-.59v-1a.61.61,0,0,1,.69-.6,6.84,6.84,0,0,0,2.74-.16c1-.27,1.66-.81,1.47-1.51s-.85-.85-2.35-.84c-2.14,0-3.8-.49-4.28-2.24-.42-1.58.4-3.1,2.32-4l-.27-1a.61.61,0,0,1,.43-.74l.58-.16a.61.61,0,0,1,.74.43l.25.9a7.64,7.64,0,0,1,2.33-.21.61.61,0,0,1,.55.6v.93a.61.61,0,0,1-.66.6,6.27,6.27,0,0,0-2.29.19c-1.19.33-1.39.91-1.27,1.35s1,.73,2.64.78c2.39.07,3.55.74,4,2.39s-.34,3.18-2.43,4.11l.31,1.11a.61.61,0,0,1-.43.74l-.58.16A.59.59,0,0,1,356.67,151.74Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_68"
                        data-name="Path 68"
                        d="M273.34,317.19c-20.87,11.87-38.29,11.13-58,.77a3.7,3.7,0,0,1-2-3.45v-.83a3.7,3.7,0,0,1,5.09-3.25c17.11,7,30,10.79,51.4.22a3.7,3.7,0,0,1,5.32,3.07h0a3.72,3.72,0,0,1-1.81,3.47Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_69"
                        data-name="Path 69"
                        d="M269.39,326.81l11.52-16.33a.81.81,0,0,0-.56-1.27l-19.09-2.33a.93.93,0,0,0-1,1.28,41.22,41.22,0,0,1,7.7,18.49.81.81,0,0,0,1.43.16Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_70"
                        data-name="Path 70"
                        d="M233.37,178.11c21-13,38.95-12.87,59.58-3a3.81,3.81,0,0,1,2.17,3.48v.86A3.81,3.81,0,0,1,290,183c-17.85-6.53-31.21-10-52.84,1.68a3.8,3.8,0,0,1-5.58-3h0A3.8,3.8,0,0,1,233.37,178.11Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_71"
                        data-name="Path 71"
                        d="M237.07,168.07l-11.23,17.22a.83.83,0,0,0,.62,1.28l19.7,1.69a1,1,0,0,0,1-1.36,42.42,42.42,0,0,1-8.61-18.72.83.83,0,0,0-1.48-.11Z"
                        fill="#fff"
                    />
                    <path
                        id="Path_72"
                        data-name="Path 72"
                        d="M181.6,420.63a1.11,1.11,0,0,0,0-.36c-1.8-7.16-10.76-11.62-10.76-11.62l-3.55.28c-2,6.31-1.78,10.18-1.45,11.9v.14a84.832,84.832,0,0,0,15.76-.34Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_73"
                        data-name="Path 73"
                        d="M165.83,421a1.54,1.54,0,0,0,1.13,1.14c4.17.88,10.79.17,13.57-.19a1.3,1.3,0,0,0,1.07-1.29,84.829,84.829,0,0,1-15.77.34Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_74"
                        data-name="Path 74"
                        d="M165.82,403.64l1.5,7.24a1.2,1.2,0,0,0,1,1,10.277,10.277,0,0,0,2.33,0,1.49,1.49,0,0,0,1.17-1.75l-1-6.43Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_75"
                        data-name="Path 75"
                        d="M197,420.88c-3.92-.11-5.95-.57-7-1v1.2a.78.78,0,0,0,.74.79l21.53-.14a1,1,0,0,0,.79-1.43C210.23,420.53,203,421.05,197,420.88Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_76"
                        data-name="Path 76"
                        d="M213.05,420.3a.891.891,0,0,0-.08-.17c-1.9-2.65-6.75-7.94-16.32-10.24l-4.59-.14s-2,3.55-2.08,10.13c1.05.43,3.08.89,7,1C203,421.05,210.23,420.53,213.05,420.3Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_77"
                        data-name="Path 77"
                        d="M191,403c.07.34,1,5.49,1.39,7.49a1,1,0,0,0,.9.85,10.559,10.559,0,0,0,3.15-.25,1.37,1.37,0,0,0,.94-1.43l-.52-8.14Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_78"
                        data-name="Path 78"
                        d="M187.53,307.9s6.31,43.39,10.87,95a2,2,0,0,1-1.63,2,23.849,23.849,0,0,1-5.13.59,1.91,1.91,0,0,1-1.81-1.59c-1.55-9.1-12.63-58-15.54-68.72,0,0-3.34,45.68-2.27,69.38a1.14,1.14,0,0,1-1,1.17,19.169,19.169,0,0,1-4.12,0,1.5,1.5,0,0,1-1.34-1.28c-1.11-7.7-7.47-53.57-7.2-86.61,0-1.86,2.18-17.17,2.18-17.17Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_79"
                        data-name="Path 79"
                        d="M159.6,310.4a1.78,1.78,0,0,1-1.17-1.51c-.84-8.15-4.9-58.66,20.77-79.44,0,0,1.47-3.86,13.57,5.61s5.62,19.39,2.72,33.08c-3.5,16.57-9.65,30.1-6.93,40.3a1.4,1.4,0,0,1-.87,1.69A40.07,40.07,0,0,1,159.6,310.4Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_80"
                        data-name="Path 80"
                        d="M189.21,214.31c0,.72-10.26,15.28-10.26,15.28s1.84,3.62,10.62,6.56l7.59-15.58Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_81"
                        data-name="Path 81"
                        d="M197.28,206s3.65,8.38,3.89,12.77,1.19,7.25-3.89,8.14-9.37-1.65-11.69-6c0,0-3.64-6.75-2.82-9.51S197.28,206,197.28,206Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_82"
                        data-name="Path 82"
                        d="M187.33,217.7l.29-.13a.69.69,0,0,0,.34-.95c-.72-1.39-2.12-4.56-.31-5.3,2.33-1,11.54-2.84,13.53-6.11a6.09,6.09,0,0,0-2.32-8.36.37.37,0,0,0-.46.15l-.21.41a.35.35,0,0,1-.64-.07h0a.34.34,0,0,0-.62-.09c-.62,1-2.27,2.57-6.68,3.38-6.27,1.16-10.42,3.7-10.52,8a.35.35,0,0,1-.54.29c-.46-.29-1.2-.42-2.19.41-1.73,1.45-1,5.21,2.76,8.3a.35.35,0,0,1,0,.56c-.68.44-1.71,1.5.94,2.92a8.9,8.9,0,0,0,5.56,1.21.34.34,0,0,0,.28-.42l-.84-3.81a.35.35,0,0,1,.34-.42Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_83"
                        data-name="Path 83"
                        d="M187.49,218.51s-1.4-5.36-3.79-3.86,1.24,6,3.17,6.2Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_84"
                        data-name="Path 84"
                        d="M196.66,239.46l.71,19a53.886,53.886,0,0,0,5.74,1.63,56.77,56.77,0,0,1,5.69-11.51,28.17,28.17,0,0,1-12.14-9.12Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_85"
                        data-name="Path 85"
                        d="M234.31,239.13C224,250.3,215.59,251,208.8,248.56a56.77,56.77,0,0,0-5.69,11.51c27.62,6.09,34.13-19.31,34.13-19.31Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_86"
                        data-name="Path 86"
                        d="M236.41,238a3.78,3.78,0,0,1,3.39-.88c2.21.4,4.17,1.17,5.55,0s1.85.4,1.85.4l-4.11,3.13Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_87"
                        data-name="Path 87"
                        d="M234,240.13s.81-3.41,3.27-2.94,8.05,3.5,9.49,2.94,3.28-1.89,4.22-1.42l-1.66,2.07s4.28-2.47,5-.95l-7.11,4S236.76,242.79,234,240.13Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_88"
                        data-name="Path 88"
                        d="M185.18,264.3s19.45,16.29,40.45,9.18a5,5,0,0,1,3.94.3l6,3.18a5.39,5.39,0,0,0,7.14-2,11.39,11.39,0,0,0,1.7-4.54l-11.82-4.78.87-1.45s-5.76-.49-7.27,3.65c0,0-11,4.57-29.52-15.81C196.71,252,188.3,259.18,185.18,264.3Z"
                        fill="#e4e3e3"
                    />
                    <path
                        id="Path_89"
                        data-name="Path 89"
                        d="M184.13,264.13a.3.3,0,0,1-.18-.06,37.31,37.31,0,0,1-12.08-14.55.33.33,0,0,1,.17-.44.34.34,0,0,1,.44.18,36.75,36.75,0,0,0,11.84,14.26.33.33,0,0,1-.19.61Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_90"
                        data-name="Path 90"
                        d="M241.67,264.17s-1.8-4.75-3.91-4.31a14.271,14.271,0,0,0-4.4,2.05L230,266.48s9.49,3.74,12.83,1.6a73.261,73.261,0,0,0,21.93-.33,48.239,48.239,0,0,1-3.45-10.4C255.09,260.86,248.41,263.48,241.67,264.17Z"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_91"
                        data-name="Path 91"
                        d="M293,229.76s-13.88,17.49-31.73,27.59a48.24,48.24,0,0,0,3.45,10.4c9.26-1.52,20-5.15,29.07-13.21Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_92"
                        data-name="Path 92"
                        d="M310.34,307.25c-2.72-12.89-5.43-20.36-14.52-44.8-2.86-7.69-5.46-15.47-4.21-23.58l1.41-9.11a68.3,68.3,0,0,1,37.25-.25s8.34,10.52,8.57,68.92C330.66,307.58,321.09,310.19,310.34,307.25Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_93"
                        data-name="Path 93"
                        d="M296,218.14l4.58,11a2.2,2.2,0,0,0,1.66,1.32c2.64.45,9,1.16,13.22-1.6a1.07,1.07,0,0,0,.29-1.5l-8.47-12.14Z"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_94"
                        data-name="Path 94"
                        d="M300.77,201.3c-.19.19-8.12,15.75-8.12,15.75l9,4.34,9.71-13.64S304,198.27,300.77,201.3Z"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_95"
                        data-name="Path 95"
                        d="M307.25,209.39l-4.48,7.47a1.13,1.13,0,0,1-.24.3c-.53.5-2.36,1.94-3.77,0-1.2-1.68-2.33-3.2-3.54-3.83a1.42,1.42,0,0,0-1.93.64,53.063,53.063,0,0,0-3.07,7.27,1.43,1.43,0,0,0,.83,1.75,40.2,40.2,0,0,0,8.61,2.51,1.43,1.43,0,0,0,1.35-.58c1.37-1.88,5.24-7.13,6.56-8.45s3.49-.76,4.51-.47a1.45,1.45,0,0,0,1.15-.15c1-.62,2.84-2.17,1.19-4.8a1.42,1.42,0,0,1,.44-1.95,3.17,3.17,0,0,0,1.21-4.5,4.46,4.46,0,0,0-4.84-2.37,1.49,1.49,0,0,1-1.56-.86,1,1,0,0,0-.74-.59,1.38,1.38,0,0,1-1.12-1.63,3.67,3.67,0,0,0-2.05-4.2c-3.88-2.14-7.27,1.34-8.14,4.27s3.47,5,6.2,5.35c2,.25,3.1,2.44,3.54,3.58a1.44,1.44,0,0,1-.11,1.24Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_96"
                        data-name="Path 96"
                        d="M305.68,218.69s1.93-4.54,4.14-4.35,3.94,2.38,1.21,4.85C307.63,222.26,305.68,218.69,305.68,218.69Z"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_97"
                        data-name="Path 97"
                        d="M308.6,420.89c4.26.37,11.67,1,17.5,1.22,3.51.16,5.53-.19,6.7-.65v.37a1.22,1.22,0,0,1-1.15,1.14,206.384,206.384,0,0,1-22.93,0,.86.86,0,0,1-.7-1.29,6.414,6.414,0,0,1,.58-.79Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_98"
                        data-name="Path 98"
                        d="M326.1,422.11c-5.83-.26-13.24-.85-17.5-1.22,4.19-5.15,17.5-8.62,17.5-8.62h3.76a15.84,15.84,0,0,1,2.94,9.19C331.63,421.92,329.61,422.27,326.1,422.11Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_99"
                        data-name="Path 99"
                        d="M330.5,406.13l-.35,7a1.6,1.6,0,0,1-1.36,1.49,6.24,6.24,0,0,1-2.83-.23,1.88,1.88,0,0,1-1.26-1.45l-1.22-6.78Z"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_100"
                        data-name="Path 100"
                        d="M379.33,422.06a3.38,3.38,0,0,0,3-2.25h0a2.41,2.41,0,0,1-1.62,2.74,10.43,10.43,0,0,1-4.49.7,4.42,4.42,0,0,1-3.36-1.55h0C374.29,422.41,376.25,422.49,379.33,422.06Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_101"
                        data-name="Path 101"
                        d="M370.61,406.09h3.1c4.73-.1,7.69,9.86,8.66,13.72a3.38,3.38,0,0,1-3,2.25c-3.08.43-5,.35-6.43-.34-2.55-3.36-3.82-8.28-4.43-11.15a3.91,3.91,0,0,1,2.1-4.48Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_102"
                        data-name="Path 102"
                        d="M373.31,399.63l1.73,6.84a1.86,1.86,0,0,1-1,2.11,6.55,6.55,0,0,1-3.57.86,1.54,1.54,0,0,1-1.26-1l-2.53-7.21Z"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_103"
                        data-name="Path 103"
                        d="M375.37,401.61c-2.14,1.9-9.11,2.15-9.11,2.15-25.1-60.24-35.57-76.83-35.57-76.83,3.63,22.74.79,81.1.79,81.1-4.15,1.83-9.49,0-9.49,0-.33-37.22-5.57-77.22-12.33-102.81,17-.39,26.18-4.08,29.13-6.41C352.93,321.6,375.37,401.61,375.37,401.61Z"
                        fill="#636464"
                    />
                    <rect
                        id="Rectangle_4"
                        data-name="Rectangle 4"
                        width="37.33"
                        height="54.32"
                        rx="5.53"
                        transform="translate(268.35 240.5)"
                        fill="#707272"
                    />
                    <rect
                        id="Rectangle_5"
                        data-name="Rectangle 5"
                        width="35.46"
                        height="52.79"
                        rx="5.53"
                        transform="translate(269.33 241.32)"
                        fill="#f4f5f6"
                    />
                    <g id="Group_2" data-name="Group 2" opacity="0.5">
                        <rect
                            id="Rectangle_6"
                            data-name="Rectangle 6"
                            width="29.3"
                            height="0.89"
                            rx="0.35"
                            transform="translate(272.19 246.59)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_7"
                            data-name="Rectangle 7"
                            width="29.3"
                            height="0.89"
                            rx="0.35"
                            transform="translate(272.19 250.7)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_8"
                            data-name="Rectangle 8"
                            width="29.3"
                            height="0.89"
                            rx="0.35"
                            transform="translate(272.41 255.01)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_9"
                            data-name="Rectangle 9"
                            width="29.3"
                            height="0.89"
                            rx="0.35"
                            transform="translate(272.41 259.12)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_10"
                            data-name="Rectangle 10"
                            width="29.3"
                            height="0.89"
                            rx="0.35"
                            transform="translate(272.3 263.56)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_11"
                            data-name="Rectangle 11"
                            width="29.3"
                            height="0.89"
                            rx="0.35"
                            transform="translate(272.3 267.67)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_12"
                            data-name="Rectangle 12"
                            width="29.3"
                            height="0.89"
                            rx="0.35"
                            transform="translate(272.53 271.98)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_13"
                            data-name="Rectangle 13"
                            width="29.3"
                            height="0.89"
                            rx="0.35"
                            transform="translate(272.53 276.09)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_14"
                            data-name="Rectangle 14"
                            width="18.85"
                            height="0.89"
                            rx="0.35"
                            transform="translate(282.98 280.6)"
                            fill="#707272"
                        />
                        <rect
                            id="Rectangle_15"
                            data-name="Rectangle 15"
                            width="18.85"
                            height="0.89"
                            rx="0.35"
                            transform="translate(283.42 285.01)"
                            fill="#707272"
                        />
                    </g>
                    <path
                        id="Path_104"
                        data-name="Path 104"
                        d="M277.06,282.71c.08.27-.27,8.46-.33,10a.1.1,0,0,0,.17.08l1.48-1.3,1.33,1.34a.17.17,0,0,0,.29-.13l-.94-9.89Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_105"
                        data-name="Path 105"
                        d="M275.69,282.13c0,.24-2.78,6.54-3.31,7.76a.07.07,0,0,0,.1.08l1.9-1.22.39,2.12a.1.1,0,0,0,.2,0l2.28-8.08Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_106"
                        data-name="Path 106"
                        d="M277.11,278.41l.9-.77.51,1.07,1.14-.34.03,1.19,1.18.15-.46,1.1,1.02.62-.87.82.68.98-1.12.39.21,1.17-1.18-.1-.27,1.16-1.05-.57-.72.95-.72-.95-1.05.57-.27-1.16-1.19.1.22-1.17-1.12-.39.68-.98-.87-.82,1.02-.62-.46-1.1,1.18-.15.03-1.19,1.14.34.51-1.07Z"
                        fill="#707272"
                    />
                    <circle
                        id="Ellipse_16"
                        data-name="Ellipse 16"
                        cx="3.16"
                        cy="3.16"
                        r="3.16"
                        transform="translate(273.228 284.294) rotate(-76.72)"
                        fill="#f4f5f6"
                    />
                    <path
                        id="Path_107"
                        data-name="Path 107"
                        d="M277,284.85a3.052,3.052,0,0,1-.52-.05.08.08,0,0,1,0-.07s0-.06.07-.05a2.889,2.889,0,0,0,.5,0,2.77,2.77,0,0,0,2.77-2.77,2.71,2.71,0,0,0-.3-1.25.06.06,0,0,1,.08-.09,2.84,2.84,0,0,1,.31,1.31,2.89,2.89,0,0,1-2.91,2.97Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_108"
                        data-name="Path 108"
                        d="M274.23,281.72h0s-.06,0-.05-.07a2.87,2.87,0,0,1,3.83-2.42.053.053,0,1,1-.08.07,2.821,2.821,0,0,0-.92-.15,2.76,2.76,0,0,0-2.75,2.47.06.06,0,0,1-.03.1Z"
                        fill="#707272"
                    />
                    <path
                        id="Path_109"
                        data-name="Path 109"
                        d="M323.76,249.44l6.51-19.93s13.37,7,19.75,33.72a42.41,42.41,0,0,0-16.08,1.42C333.9,257.24,323.76,249.44,323.76,249.44Z"
                        fill="#5c5c5c"
                    />
                    <path
                        id="Path_110"
                        data-name="Path 110"
                        d="M305.3,264s17.87,14.69,26.24,6.29a7.62,7.62,0,0,0,2.4-5.6A42.409,42.409,0,0,1,350,263.23a21.35,21.35,0,0,1-4.81,14c-15.48,19.38-43.39-8.84-43.39-8.84Z"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_111"
                        data-name="Path 111"
                        d="M304.18,269s2.6-5.94,2.38-8.24-.91-5.34-4.94-5.41a58.45,58.45,0,0,0-9,.78,2.28,2.28,0,0,0,2.87,2.51l-2.1,1.11s-.14,2.34,2.6,1.56L294,262.87a2,2,0,0,0,2.82,1.19C298.86,263.18,298.79,268.79,304.18,269Z"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_112"
                        data-name="Path 112"
                        d="M333.94,264.78a.13.13,0,0,1-.12-.11c-1-5.64-4.61-11.21-11.46-17.52a.13.13,0,0,1,.17-.19c6.9,6.35,10.56,12,11.54,17.67a.14.14,0,0,1-.11.15Z"
                        opacity="0.5"
                    />
                    <circle
                        id="Ellipse_17"
                        data-name="Ellipse 17"
                        cx="11.83"
                        cy="11.83"
                        r="11.83"
                        transform="translate(3.39 126.45)"
                        fill="#fff"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <circle
                        id="Ellipse_18"
                        data-name="Ellipse 18"
                        cx="8.05"
                        cy="8.05"
                        r="8.05"
                        transform="translate(34.97 84.53)"
                        fill="#fff"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <circle
                        id="Ellipse_19"
                        data-name="Ellipse 19"
                        cx="8.68"
                        cy="8.68"
                        r="8.68"
                        transform="translate(434.91 163.53)"
                        fill="#fff"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <circle
                        id="Ellipse_20"
                        data-name="Ellipse 20"
                        cx="14.24"
                        cy="14.24"
                        r="14.24"
                        transform="translate(455.48 110.82)"
                        fill="#fff"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <path
                        id="Path_113"
                        data-name="Path 113"
                        d="M52.14,334.47H43.7V326a1,1,0,0,0-1.05-1h0a1.07,1.07,0,0,0-1.07,1v8.43H33.16a1.035,1.035,0,1,0,0,2.07h8.42V345a1.07,1.07,0,0,0,1.07,1,1,1,0,0,0,1.05-1h0v-8.45h8.44a1.06,1.06,0,1,0,0-2.12Z"
                        fill="#e2e2e2"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_114"
                        data-name="Path 114"
                        d="M505.78,295.91h-6.69v-6.67a.83.83,0,0,0-.83-.83h0a.85.85,0,0,0-.85.83v6.67h-6.67a.86.86,0,0,0-.84.85.85.85,0,0,0,.84.84h6.67v6.68a.85.85,0,0,0,.85.83.83.83,0,0,0,.83-.83h0V297.6h6.69a.85.85,0,0,0,.84-.84.86.86,0,0,0-.84-.85Z"
                        fill="#e2e2e2"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_115"
                        data-name="Path 115"
                        d="M260.5,70.86h-6.05v-6a.76.76,0,0,0-.75-.75h0a.77.77,0,0,0-.77.75v6h-6a.76.76,0,1,0,0,1.52h6v6.05a.77.77,0,0,0,.77.75.75.75,0,0,0,.75-.75h0V72.38h6.05a.76.76,0,1,0,0-1.52Z"
                        fill="#e2e2e2"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_116"
                        data-name="Path 116"
                        d="M217.51,55.69h-8.44V47.26a1,1,0,0,0-1-1h0a1.07,1.07,0,0,0-1.07,1v8.43h-8.42a1.06,1.06,0,1,0,0,2.12H207v8.45a1.07,1.07,0,0,0,1.07,1,1,1,0,0,0,1-1h0V57.81h8.44a1.06,1.06,0,0,0,0-2.12Z"
                        fill="#e2e2e2"
                        stroke="#e2e2e2"
                        strokeMiterlimit="10"
                        strokeWidth="0.75"
                    />
                </g>
            </g>
        </SVGIcon>
    );
}
